import dashboardOffIcon from '../../assets/images/menu/dashboardOff.svg';
import dashboardOnIcon from '../../assets/images/menu/dashboardOn.svg';
import usersOffIcon from '../../assets/images/menu/usersOff.svg';
import usersOnIcon from '../../assets/images/menu/usersOn.svg';
import commandersOffIcon from '../../assets/images/menu/commandersOff.svg';
import commandersOnIcon from '../../assets/images/menu/commandersOn.svg';
import sensorsOffIcon from '../../assets/images/menu/sensorsOff.svg';
import sensorsOnIcon from '../../assets/images/menu/sensorsOn.svg';
import noticesOnIcon from '../../assets/images/menu/noticesOn.svg';
import noticesOffIcon from '../../assets/images/menu/noticesOff.svg';
import relationshipsOffIcon from '../../assets/images/menu/relationshipsOff.svg';
import relationshipsOnIcon from '../../assets/images/menu/relationshipsOn.svg';
import caregiversOffIcon from '../../assets/images/menu/caregiversOff.svg';
import caregiversOnIcon from '../../assets/images/menu/caregiversOn.svg';
import healthcareFacilitiesOffIcon from '../../assets/images/menu/healthcareFacilitiesOff.svg';
import healthcareFacilitiesOnIcon from '../../assets/images/menu/healthcareFacilitiesOn.svg';
import intakeOffIcon from '../../assets/images/menu/intakeOff.svg';
import intakeOnIcon from '../../assets/images/menu/intakeOn.svg';

// Configuration constants
export const RootPathName = 'Heartkium';
export const Type = 'Drawer'; //AppBar, Drawer
export const drawerMaxWidth = 240;
export const drawerMinWidth = 56;
export const isDrawerOpen = false;

// 공통 하위메뉴 정의
export const CommonSubMenus = {
  users: [
    { name: 'menu_users', path: '/users' },
    { name: 'add', path: '/users/add' },    
    { name: 'status_diaper_change', path: '/users/changeDiaper' },
    { name: 'common_detail', path: '/users/detail' },
    { name: 'common_edit', path: '/users/intakeAdd' },
    { name: 'medication_setting_title', path: '/users/medicationSettingAdd' },
    { name: 'my_info', path: '/users/my-info' }
  ],
  sensors: [
    { name: 'menu_sensors', path: '/sensors' },
    { name: 'add', path: '/sensors/add' },
    { name: 'common_detail', path: '/sensors/detail' },
    { name: 'common_edit', path: '/sensors/edit' }
  ],
  relationships: [
    { name: 'menu_relationships', path: '/relationships' },
    { name: 'add', path: '/relationships/add' },    
  ],
  caregivers: [
    { name: 'caregiver', path: '/caregivers' },
    { name: 'add', path: '/caregivers/add' },
    { name: 'common_edit', path: '/caregivers/edit' }
  ],
  hospitals: [
    { name: 'my_info_hospital', path: '/hospitals' },
    { name: 'add', path: '/hospitals/add' },
    { name: 'common_edit', path: '/hospitals/edit' }
  ],
  commanders: [
    { name: 'menu_commanders', path: '/commanders' },
    { name: 'add', path: '/commanders/add' },   
    { name: 'common_edit', path: '/commanders/edit' },
    { name: 'common_edit', path: '/commanders/editSlot' }
  ],
  notices: [
    { name: 'notices', path: '/notices' }  
  ]  
};

// Menu definitions
export const SuperAdminDefinition = [   
  {
    name: 'menu_dashboard',
    path: '/',
    icon: {
      active: dashboardOnIcon,
      inactive: dashboardOffIcon
    }
  },
  {
    name: 'my_info_hospital',
    path: '/hospitals',
    icon: {
      active: healthcareFacilitiesOnIcon,
      inactive: healthcareFacilitiesOffIcon,     
    },
    subMenus: CommonSubMenus.hospitals
  },
  {
    name: 'menu_users',
    path: '/users',
    icon: {
      active: usersOnIcon,
      inactive: usersOffIcon
    },
    subMenus: CommonSubMenus.users
  },
  {
    name: 'menu_commanders',
    path: '/commanders',
    icon: {
      active: commandersOnIcon,
      inactive: commandersOffIcon,     
    },
    subMenus: CommonSubMenus.commanders
  },
  { name: 'food_intake_medication_record_table', 
    path: '/intakes',
    icon: {
      active: intakeOnIcon,
      inactive: intakeOffIcon
    }
  },
  {
    name: 'notices',
    path: '/notices',
    icon: {
      active: noticesOnIcon,
      inactive: noticesOffIcon,    
    },
    subMenus: CommonSubMenus.notices
  }
];

export const AdminDefinition = [
    {
      name: 'menu_dashboard',
      path: '/',
      icon: {
        active: dashboardOnIcon,
        inactive: dashboardOffIcon
      }
    },
    {
      name: 'menu_users',
      path: '/users',
      icon: {
        active: usersOnIcon,
        inactive: usersOffIcon
      },
      subMenus: CommonSubMenus.users
    },
    {
      name: 'menu_commanders',
      path: '/commanders',
      icon: {
        active: commandersOnIcon,
        inactive: commandersOffIcon
      },
      subMenus: CommonSubMenus.commanders
    },
    { name: 'food_intake_medication_record_table', 
      path: '/intakes',
      icon: {
        active: intakeOnIcon,
        inactive: intakeOffIcon
      }
    },
    {
      name: 'menu_sensors',
      path: '/sensors',
      icon: {
        active: sensorsOnIcon,
        inactive: sensorsOffIcon
      },
      subMenus: CommonSubMenus.sensors
    },    
    {
      name: 'notices',
      path: '/notices',
      icon: {
        active: noticesOnIcon,
        inactive: noticesOffIcon,    
      },
      subMenus: CommonSubMenus.notices
    },
    {
      name: 'menu_relationships',
      path: '/relationships',
      icon: {
        active: relationshipsOnIcon,
        inactive: relationshipsOffIcon,        
      },
      subMenus: CommonSubMenus.relationships
    },
    {
      name: 'caregiver',
      path: '/caregivers',
      icon: {
        active: caregiversOnIcon,
        inactive: caregiversOffIcon,        
      },
      subMenus: CommonSubMenus.caregivers
    }
    // ,
    // {
    //   path: '/schedules',
    //   name: 'Schedules',
    //   icon: <CalendarIcon/>,
    // },
    // {
    //   path: '/records',
    //   name: 'Records',  
    //   icon: <RecordIcon/>,
    // } 
];

export const CommanderDefinition = [
  {
    name: 'menu_commanders',
    path: '/commanders',
    icon: {
      active: commandersOnIcon,
      inactive: commandersOffIcon
    },
    subMenus: CommonSubMenus.commanders
  }
];

export const ManagerDefinition = [
  {
    name: 'menu_dashboard',
    path: '/',
    icon: {
      active: dashboardOnIcon,
      inactive: dashboardOffIcon
    }
  },
  {
    name: 'menu_users',
    path: '/users',
    icon: {
      active: usersOnIcon,
      inactive: usersOffIcon
    },
    subMenus: CommonSubMenus.users
  }
];

export const UserDefinition = [
  {
    name: 'menu_users',
    path: '/users',
    icon: {
      active: usersOnIcon,
      inactive: usersOffIcon
    },
    subMenus: CommonSubMenus.users
  } ,
  {
    name: 'menu_relationships',
    path: '/relationships',
    icon: {
      active: relationshipsOnIcon,
      inactive: relationshipsOffIcon
    },
    subMenus: CommonSubMenus.relationships
  }
];